export default "#### Already speaking with Carma, or someone else about finance?\n\nLet us know the details so we can make it a smooth process.\n";